import React from 'react';
import { Grid, Typography } from '@material-ui/core';

export default function InvoiceClosing({ data }) {
  const { description } = data;

  return(
    <Grid container>
      <Grid xs={12}>
        <Typography color='primary'>
          {description}
        </Typography>
      </Grid>
    </Grid>
  );
}